<template>
  <el-cascader v-model="changeValue" popper-class="t-cascader-popper" :options="getOptions()" v-bind="{ ...item }" />
</template>

<script>
import mixin from '../mixin'

export default {
  name: 'TCascader',
  mixins: [mixin],
  data() {
    return {}
  }
}
</script>

<style scoped>
test {
  color: rgba(95, 127, 157, 1);
}
::v-deep .el-cascader-panel {
  font-size: 16px;
}
</style>
<style>
.el-cascader-panel {
  font-size: 16px;
}
</style>
